var map = {
	"./AT.svg": "883d",
	"./BA.svg": "d900",
	"./BG.svg": "be91",
	"./CZ.svg": "b0b3",
	"./DE.svg": "81a3",
	"./HR.svg": "bcad",
	"./HU.svg": "a61a",
	"./MD.svg": "b830",
	"./RO.svg": "b816",
	"./RS.svg": "40b9",
	"./SI.svg": "6500",
	"./SK.svg": "2a74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79d7";